import React, { useState, useEffect, useMemo } from "react";
import BarChart from "../chart/BarChart";
import { Form, Button } from 'react-bootstrap';
import { BsArrowUpRight } from "react-icons/bs";
import ProductionTargetProgress from "./ProductionTargetProgress";
import config from "../../config/config";
import { toast } from "react-toastify";
import axios from "axios";
import ManpowerAllocationModal from '../modal/ManpowerAllocationModal'
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate"
import Loader from "../loader/Loader";
import MaterialIssueRequstModal from "../modal/MaterialIssueRequstModal";
import ValidateProductionLog from "../modal/ValidateProductionLog"
import Select from "react-select";
import DispatchForm from "./DispatchModal";
const Production = () => {
  const [productId, setProductId] = useState(null);
  const today = new Date().toISOString().slice(0, 10);
  const [productOptions, setProductOptions] = useState([]);
  const updatedOptions = useMemo(() => {
    return [{ label: "All", value: 0 }, ...(productOptions || [])];
  }, [productOptions]);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [selectedItem, setSelectedItem] = useState(null);
  const [target, setTarget] = useState([]);
  const [loading, setLoading] = useState(false);
  const [materialIssue, setMaterialIssue] = useState(false)
  const [validateProductionLog, setValidateProductionLog] = useState(false)
  const [logId, setLogId] = useState(null);
  const [productionDate, setProductionDate] = useState(null);
  const [shift, setShift] = useState(null)
  const [alertsscreen, setAlertsscreen] = useState([])
  const [manpowerAllocation, setManpowerAllocation] = useState(false)
  const [selectedMachineForAssign, setSelectedMachineForAssign] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [machineOperator, setMachineOperator] = useState({
    operators: [],
    machines: []
  });
  const [formData, setFormData] = useState({
    po_number: "",
    product_name: productId,
    rejected_quantity: "",
    rejected_date: "",
    remarks: "",
  });
  const [dailyproductionoverview, setDailyproductionoverview] = useState({
    labels: [],
    datasets: [
      {
        label: "Planned",
        data: [],
        backgroundColor: "#0a28a3",
      },
      {
        label: "Actual",
        data: [],
        backgroundColor: "#4ea0f0",
      },
    ],
  });
  useEffect(() => {
    fetchTarget();
    fetchAlertsscreen();
    fetchProductList();
    DailyProductionoverview();
  }, []);
  const fetchTarget = async (start_date, end_date) => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API}/supervisor/target_report`,
        {
          start_date,
          end_date,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data) {
        setTarget(response?.data?.data || []);
      } else {
        setTarget([]);
      }
    } catch (error) {
      console.error("Error fetching target report:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = getAuthToken();
    if (!token) return;
    const {
      po_number: poNumber,
      product_name,
      product_id,
      rejected_qty: rejected_quantity,
      rejected_date,
      remarks,
    } = formData;

    const finalPoNumber = poNumber ?? 1;
    console.log("Form Data:", formData); // Debugging line
    if (!finalPoNumber || !product_name || !rejected_quantity || !rejected_date) {
      alert("Please fill in all required fields.");
      return;
    }
    const payload = {
      po_number: finalPoNumber,
      product_name,
      product_id,
      rejected_qty: rejected_quantity,
      rejected_date: formatDate(rejected_date),
      remarks,
    };

    try {
      const response = await axios.post(
        `${config.API}/supervisor/rejectonfinsh`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        toast.success(response.data?.message || "Rejection record saved successfully");
        setFormData({
          po_number: "",
          product_name: "",
          rejected_qty: "",
          rejected_date: "",
          remarks: "",
        });
        setProductId(null);
      } else {
        toast.error(response.data?.message || "Failed to save rejection record");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred");
      setAlertsscreen([]);
    }
  };
  const fetchAlertsscreen = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/alertsscreen`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setAlertsscreen(response?.data || []);
      } else {
        setAlertsscreen([]);
      }
    } catch (err) {
      console.error("Error fetchAlertsscreen:", err.message);
      toast.error("Error fetching alerts screen");
    } finally {
      setLoading(false);
    }
  };

  const DailyProductionoverview = async (productId = null) => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.API}/supervisor/dailyproductionoverview`,
        {
          product_id: productId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = response?.data?.production_summary || [];
      const dailyProductionDate = response?.data?.date || "00/00/0000";
      if (result.length > 0) {
        setDailyproductionoverview({
          labels: [dailyProductionDate],
          datasets: [
            {
              label: "Planned",
              data: result.map((item) => Number(item?.planned)),
              backgroundColor: "#0a28a3",
            },
            {
              label: "Actual",
              data: result.map((item) =>
                Number(item?.total_units_produced)
              ),
              backgroundColor: "#4ea0f0",
            },
          ],
        });
      } else {
        setDailyproductionoverview(null);
      }
    } catch (err) {
      toast.error("Error fetching daily production overview");
      console.error("Error DailyProductionoverview:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleButtonClick = (btn, id, productionDate, shift) => {
    if (btn === "Issue Material") {
      setMaterialIssue(true);
    } else {
      setLogId(id);
      setProductionDate(productionDate);
      setShift(shift)
      setValidateProductionLog(true);
    }
  };
  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProductOptions(
        response?.data?.products?.map((plist) => ({
          value: plist.id,
          label: plist.name,
        })) || []
      );
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMachineOperator = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/machineuser`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response?.data || { operators: [], machines: [] };
      setMachineOperator(data);
    } catch (err) {
      console.error("Error fetching machine/operator:", err.message);
      setMachineOperator({ operators: [], machines: [] });
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    if (fromDate && toDate) {
      fetchTarget(fromDate, toDate);
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    fetchMachineOperator()
  }, [])

  return (
    <div className="container-fluid">
      <div className="row g-4">
        <div className={!selectedItem ? "col-md-8 d-flex" : "col-12"}>
          {!selectedItem ? (
            <div className="card flex-fill">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 p-2">
                <strong className="fs-5 font_family text-wrap text-md-nowrap">
                  Product Wide Production Target + Progress
                </strong>
                <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2 w-100 w-md-auto">
                  <Form.Control
                    type="date"
                    size="sm"
                    className="w-100 w-sm-auto"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <Form.Control
                    type="date"
                    size="sm"
                    className="w-100 w-sm-auto"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <Button
                    size="sm"
                    variant="primary"
                    className="w-100 w-sm-auto"
                    disabled={!fromDate || !toDate}
                    onClick={() => fetchTarget(fromDate, toDate)}
                  >
                    Apply
                  </Button>

                </div>
              </div>
              <div className="card-body" style={{ maxHeight: '320px', overflowY: 'auto' }}>
                {loading ? (
                  <Loader />
                ) : target && target.length > 0 ? (
                  target.map((item, idx) => {
                    const percentage = ((item.total_produced / item.target) * 100).toFixed(2);
                    return (
                      <div key={idx} className="mb-3">
                        <div className="d-flex justify-content-between mb-1">
                          <span
                            style={{ cursor: "pointer", fontWeight: 500 }}
                            onClick={() => setSelectedItem(item)}
                          >
                            {item.product?.name} <BsArrowUpRight />
                          </span>
                          <span>
                            {item.total_produced}/{item.target} ({percentage}%)
                          </span>
                        </div>
                        <div className="progress" style={{ height: "8px" }}>
                          <div
                            className={`progress-bar ${percentage >= 100 ? "bg-success" : "bg-dark"}`}
                            style={{ width: `${percentage}%` }}
                          ></div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center text-muted py-3">
                    No data found
                  </div>
                )}
              </div>

            </div>
          ) : (
            <ProductionTargetProgress item={selectedItem} onBack={() => setSelectedItem(null)} />
          )}
        </div>
        {!selectedItem && (
          <div className="col-md-4 d-flex mb-3">
            <div className="card flex-fill font_family">
              <div className="card-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                <strong className="fs-3">Alerts</strong>

                {loading ? (
                  <Loader />
                ) : (
                  <>
                    {(
                      (alertsscreen?.low_material && alertsscreen?.low_material?.length > 0) ||
                      (alertsscreen?.productionlog && alertsscreen?.productionlog?.length > 0)
                    ) ? (
                      <>
                        {alertsscreen?.low_material?.map((alert, idx) => (
                          <div
                            key={`low_${idx}`}
                            className="border-start border-danger ps-3 py-2 my-3 border-4 bg-danger bg-opacity-10"
                          >
                            <div className="fw-bold">Low Material Alert</div>
                            <div className="small mb-2">
                              {alert?.material?.material_name} is running low
                            </div>
                            <button
                              className="btn btn-sm bg-white"
                              onClick={() => handleButtonClick("Issue Material")}
                            >
                              Issue Material
                            </button>
                          </div>
                        ))}
                        {alertsscreen?.productionlog?.map((log, idx) => {
                          return (
                            <div
                              key={`log_${idx}`}
                              className="border-start border-danger ps-3 py-2 my-3 border-4 bg-danger bg-opacity-10"
                            >
                              <div className="fw-bold">
                                Production Log For {log?.user?.name} {log?.shift} Shift
                              </div>

                              <div className="small mb-2">
                                {(log?.summary_accepted_at)} - {log?.product?.name} is pending validation
                              </div>

                              <button
                                className="btn btn-sm bg-white"
                                onClick={() =>
                                  handleButtonClick(
                                    log?.button,
                                    log?.user?.id,
                                    log?.production_date,
                                    log?.shift
                                  )
                                }
                              >
                                Validate Production Log
                              </button>
                            </div>
                          );
                        })}
                        {alertsscreen?.machinesetup?.map((log, idx) => {
                          return (
                            <div
                              key={`log_${idx}`}
                              className="border-start border-warning ps-3 py-2 my-3 border-4 bg-warning bg-opacity-10"
                            >
                              <div className="fw-bold">
                                Operator Assignment Required
                              </div>

                              <div className="small mb-2">
                                Machine <b>{log?.machine?.machine_code}</b> is ready with product setup.
                                Please assign an operator.
                              </div>

                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() => {
                                  setSelectedMachineForAssign(log?.machine?.machine_code);
                                  setManpowerAllocation(true);
                                }}
                              >
                                Assign Operator
                              </button>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-center text-muted py-3">
                        No alerts found
                      </div>
                    )}
                  </>
                )}
              </div>

            </div>
          </div>
        )}
      </div>
      <div className="container mt-4">
        <div className="card shadow">
          <div className="card-header bg-primary text-white">
            <h4 className="mb-0">Rejection on Finished Area</h4>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Product Name
                  </label>
                  <Select
                    options={productOptions}
                    placeholder={"Select Product"}
                    isClearable
                    onChange={(selected) => {
                      if (selected) {
                        setFormData({
                          ...formData,
                          po_number: 1,
                          product_id: selected.value,
                          product_name: selected.label,
                          rejected_quantity: selected.rejected_quantity,
                          rejected_date: selected.rejected_date,
                          remarks: selected.remarks
                        });
                      } else {
                        setFormData({
                          ...formData,
                          product_id: null,
                          product_name: null,
                          rejected_quantity: null,
                        });
                      }
                    }}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Rejected Quantity
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="rejected_qty"
                    value={formData.rejected_qty}
                    onChange={handleChange}
                    placeholder="Enter Rejected Quantity"
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Rejection Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="rejected_date"
                    value={formData.rejected_date}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">
                    Remarks
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleChange}
                    placeholder="Enter Remarks"
                  ></textarea>
                </div>

              </div>

              <div className="text-end">
                <button
                  type="reset"
                  className="btn btn-secondary me-2"
                >
                  Reset
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                >
                  Save Rejection
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container mt-4">
              <DispatchForm
        selectedRow={selectedRow}
        onSuccess={() => {
          // fetchProduction(); // Refresh your table after a successful save
        }}
      />
      </div>
      {!selectedItem && (
        <div className="row mt-4">
          <div className="col-12 d-flex">
            <div className="p-3 border rounded bg-light w-100">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <strong className="fs-4">Daily Production Overview</strong>

                <div style={{ width: "320px" }}>
                  <Select
                    options={productOptions}
                    placeholder={"Select Product"}
                    isClearable
                    onChange={(selected) => {
                      if (selected) {
                        DailyProductionoverview(selected.value);
                      } else {
                        DailyProductionoverview(null);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="p-4">
                <BarChart chartData={dailyproductionoverview} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MaterialIssueRequstModal */}
      <MaterialIssueRequstModal
        show={materialIssue}
        handleClose={() => setMaterialIssue(false)}
      />
      {/* ValidateProductionLog */}
      <ValidateProductionLog
        show={validateProductionLog}
        logId={logId}
        shift={shift}
        productionDate={productionDate}
        handleClose={() => setValidateProductionLog(false)}
      />
      {/* ManpowerAllocationModal */}
      <ManpowerAllocationModal
        show={manpowerAllocation}
        handleClose={() => setManpowerAllocation(false)}
        machineOperator={machineOperator}
        selectedMachineForAssign={selectedMachineForAssign}
      />

    </div>
  );
};

export default Production;